import { ActionReducer } from '@ngrx/store';
import { StateManagementHelpers } from '../../helpers';
import * as HydrationStatusActions from '../actions/hydration-status.action';
import {
  HydrationRoles,
  HydrationSources,
  IHydrationStatusStore,
} from '../interfaces/hydration-status-store.interface';

const defaultHydrationStatus: IHydrationStatusStore = {
  hydrationRole: HydrationRoles.empty,
  hydrationSource: HydrationSources.empty,
};

export const hydrationStatusReducer: ActionReducer<
  IHydrationStatusStore | undefined,
  any
> = (
  // eslint-disable-next-line default-param-last
  state: IHydrationStatusStore = defaultHydrationStatus,
  action: any,
): IHydrationStatusStore | undefined => {
  switch (action.type) {
    case HydrationStatusActions.HYDRATION_SOURCE:
      return StateManagementHelpers.mergeState(state, {
        hydrationSource: action.hydrationSource,
      }) as IHydrationStatusStore;
    case HydrationStatusActions.ALL:
      return StateManagementHelpers.mergeState(state, {
        hydrationRole: action.hydrationRole,
        hydrationSource: action.hydrationSource,
      }) as IHydrationStatusStore;
    default:
      return state;
  }
};
